function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", {
  id: "defs815"
}, /*#__PURE__*/React.createElement("filter", {
  id: "filter6161",
  height: 1.5,
  width: 1.5,
  y: -0.25,
  x: -0.25
}, /*#__PURE__*/React.createElement("feGaussianBlur", {
  id: "feGaussianBlur6139",
  result: "result1",
  stdDeviation: 1
}), /*#__PURE__*/React.createElement("feComposite", {
  id: "feComposite6141",
  operator: "in",
  result: "result4",
  in2: "result1",
  in: "result1"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  id: "feGaussianBlur6143",
  in: "result4",
  result: "result6",
  stdDeviation: 7
}), /*#__PURE__*/React.createElement("feComposite", {
  id: "feComposite6145",
  result: "result8",
  in2: "result4",
  in: "result6",
  operator: "over"
}), /*#__PURE__*/React.createElement("feComposite", {
  id: "feComposite6147",
  in2: "result8",
  in: "result6",
  result: "fbSourceGraphic",
  operator: "in"
}), /*#__PURE__*/React.createElement("feSpecularLighting", {
  id: "feSpecularLighting6151",
  in: "fbSourceGraphic",
  result: "result1",
  lightingColor: "rgb(255,255,255)",
  surfaceScale: 2.5,
  specularConstant: 2,
  specularExponent: 45
}, /*#__PURE__*/React.createElement("fePointLight", {
  id: "fePointLight6149",
  x: -5000,
  y: -10000,
  z: 20000
})), /*#__PURE__*/React.createElement("feComposite", {
  id: "feComposite6153",
  in2: "fbSourceGraphic",
  in: "result1",
  result: "result2",
  operator: "in"
}), /*#__PURE__*/React.createElement("feComposite", {
  id: "feComposite6155",
  in2: "result2",
  in: "fbSourceGraphic",
  result: "result4",
  operator: "arithmetic",
  k2: 1.2,
  k3: 1.5
}), /*#__PURE__*/React.createElement("feComposite", {
  id: "feComposite6157",
  result: "result9",
  in2: "result4",
  in: "result9",
  operator: "over"
}), /*#__PURE__*/React.createElement("feBlend", {
  id: "feBlend6159",
  in2: "result9",
  mode: "screen"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter6167"
}, /*#__PURE__*/React.createElement("feGaussianBlur", {
  id: "feGaussianBlur6165",
  result: "blur",
  stdDeviation: "44.39 2"
})));

var _ref3 = /*#__PURE__*/React.createElement("metadata", {
  id: "metadata818"
}, /*#__PURE__*/React.createElement("useless", null, /*#__PURE__*/React.createElement("useless", {
  useless: ""
}, /*#__PURE__*/React.createElement("useless", null, "image/svg+xml"), /*#__PURE__*/React.createElement("useless", {
  useless: "http://purl.org/dc/dcmitype/StillImage"
}), /*#__PURE__*/React.createElement("useless", null))));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "layer1"
});

var _ref5 = /*#__PURE__*/React.createElement("g", {
  id: "layer4"
});

var _ref6 = /*#__PURE__*/React.createElement("g", {
  id: "g968"
}, /*#__PURE__*/React.createElement("path", {
  id: "path964-7-5",
  d: "m 52.33568,65.569807 c -1e-6,-5.023408 2.526806,-9.729888 6.789062,-12.330078 4.262256,-2.60019 9.651807,-2.60019 13.914063,0 4.262255,2.600189 6.789062,7.306669 6.789062,12.330078 h -8.089844 c 0,-2.300831 -1.171379,-4.363848 -2.912109,-5.42578 -1.74073,-1.061931 -3.747551,-1.061932 -5.488281,0 -1.74073,1.061932 -2.91211,3.124949 -2.91211,5.42578 z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path964",
  d: "m 52.33568,65.569807 c -1e-6,5.023409 2.526806,9.729889 6.789062,12.330078 4.262256,2.600189 9.651807,2.600189 13.914063,0 4.262255,-2.600189 6.789062,-7.306669 6.789062,-12.330078 h -8.089844 c 0,2.300832 -1.171379,4.363849 -2.912109,5.425781 -1.74073,1.061932 -3.747551,1.061932 -5.488281,0 -1.74073,-1.061932 -2.91211,-3.124949 -2.91211,-5.425781 z"
}), /*#__PURE__*/React.createElement("rect", {
  transform: "rotate(90)",
  ry: 0.00000359872,
  y: -69.995758,
  x: 10.282874,
  height: 7.8125,
  width: 48.082275,
  id: "rect962"
}), /*#__PURE__*/React.createElement("rect", {
  transform: "scale(1,-1)",
  ry: 0.00000359872,
  y: -18.153706,
  x: 22.312838,
  height: 7.8125,
  width: 46.881676,
  id: "rect962-5"
}), /*#__PURE__*/React.createElement("path", {
  id: "path964-7-3",
  d: "m 14.37537,0.318061 c -5.0234098,0 -9.7298898,2.52681 -12.3300798,6.78906 -2.60019003,4.26226 -2.60019003,9.65181 0,13.91407 2.60019,4.26225 7.30667,6.78906 12.3300798,6.78906 v -8.08985 c -2.30083,0 -4.36385,-1.17137 -5.4257798,-2.9121 -1.06193,-1.74073 -1.06193,-3.74756 0,-5.48829 C 10.01152,9.579281 12.07454,8.407901 14.37537,8.407901 Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path964-6-5",
  d: "m 14.37537,0.318061 c 5.02341,0 9.72989,2.52681 12.33007,6.78906 2.60019,4.26226 2.60019,9.65181 0,13.91407 -2.60018,4.26225 -7.30666,6.78906 -12.33007,6.78906 v -8.08985 c 2.30083,0 4.36385,-1.17137 5.42578,-2.9121 1.06193,-1.74073 1.06193,-3.74756 0,-5.48829 -1.06193,-1.74073 -3.12495,-2.91211 -5.42578,-2.91211 z"
}));

var SvgMapWestSouthWire = function SvgMapWestSouthWire(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "SVGRoot",
    viewBox: "0 0 80 80",
    height: "80px",
    width: "80px",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMapWestSouthWire, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/map-west-south-wire.43b88e2e.svg";
export { ForwardRef as ReactComponent };